import script from "./ValidatorSessionData.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorSessionData.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorSessionData.vue?vue&type=style&index=0&id=f87edc44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f87edc44"]])

export default __exports__